import { useEffect, useState } from "react";

const HamburgerIcon = ({ className, fill }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-6";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-6";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke={fill || "#1a1a1a"}
      className={_class}
    >
      <path
        d="M3 6h18M3 12h18M3 18h18"
        stroke={fill || "#1a1a1a"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HamburgerIcon;
